import React from "react";
import "../dropmenu/Location.css";

function Leadership() {
  return (
    <>
      <div className="loc">
        <div className="AtextL">
          <h1>Meet our Leadership Team</h1>
          <h2>
            At Essendant, leadership means integrity, forward thinking and
            purpose-driven decision-making. Here’s the team whose talents,
            expertise and skills guide our strategic direction and help move us
            forward.
          </h2>
        </div>
        <div className="dis3">
          <div className="leaders">
            <img alt="" src="./Dropdown/H_Dochelli.jpg" />
            <h4 className="nm">Harry Dochelli</h4>
            <h4>President & CEO</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/J_Bobroff.jpg" />
            <h4 className="nm">Jeff Bobroff</h4>
            <h4>
              Senior Vice President, Merchandising and Fulfillment Services
            </h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/C_Cizek.jpg" />
            <h4 className="nm">Craig Cizek</h4>
            <h4>Senior Vice President, Pricing and Profitability Analytics</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/T_Engstrom.png" />
            <h4 className="nm">Tim Engstrom</h4>
            <h4>Senior Vice President, Supply Chain</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/A_Kiss.png" />
            <h4 className="nm">Andy Kiss</h4>
            <h4>Senior Vice President, Information Technology</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/M_Rubin.jpg" />
            <h4 className="nm">Marsha Rubin</h4>
            <h4>Senior Vice President, General Counsel</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/R_Starr.jpg" />
            <h4 className="nm">Renee Starr</h4>
            <h4>Senior Vice President, Sales</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/M_Sztainberg.jpg" />
            <h4 className="nm">Marcela Sztainberg</h4>
            <h4>Senior Vice President, Human Resources</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/A_Wadhams.jpg" />
            <h4 className="nm">Allison Wadhams</h4>
            <h4>Senior Vice President, Customer Care and Sales Ops</h4>
          </div>
          <div className="leaders">
            <img alt="" src="./Dropdown/R_Wharton.jpg" />
            <h4 className="nm">Ryon Wharton</h4>
            <h4>Senior Vice President, Finance and CFO</h4>
          </div>
        </div>
      </div>
      <hr className="Aline" />
    </>
  );
}

export default Leadership;
